import { CTA } from "common/styleguide/CTA";
import { Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { AppStoreCancelDialog, APP_STORE_CANCEL_DIALOG } from "../dialogs/AppStoreCancelDialog";
import { paymentsMessages } from "../intlMessages";
import basicIcon from "./basic-circle.png";
import basicIcon2x from "./basic-circle@2x.png";
import basicIcon3x from "./basic-circle@3x.png";
import premiumIcon from "./premium-circle.png";
import premiumIcon2x from "./premium-circle@2x.png";
import premiumIcon3x from "./premium-circle@3x.png";
import styles from "./UpdatePayment.scss";

export class UpdatePayment extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dialog: null,
    };
  }

  showDialog = () => {
    this.setState({ dialog: APP_STORE_CANCEL_DIALOG });
  };

  hideDialog = () => {
    this.setState({ dialog: null });
  };

  render() {
    const { dialog } = this.state;
    const { accountLevel, appleContinue } = this.props;

    return (
      <div className={styles.UpdatePayment}>
        {dialog === APP_STORE_CANCEL_DIALOG && (
          <AppStoreCancelDialog gotIt={appleContinue} onRequestClose={this.hideDialog} />
        )}
        <div className={styles.container}>
          <div className={styles.upgrade}>
            <h2>
              <Msg m={paymentsMessages.upgradeAccount} />
            </h2>
            <div className={styles.line} />
            <div className={styles.explainer}>
              <T
                id="UpdatePayment.itunes"
                defaultMessage="It looks like you purchased your subscription through <b>iTunes</b>. Make sure to cancel your current subscription through the Apple Store before proceeding to upgrade."
                values={{ b: (...c) => <b>{c}</b> }}
              />
            </div>
            <CTA className={styles.heroCTA} onClick={appleContinue}>
              <T id="UpdatePayment.continue" defaultMessage="Continue to Upgrade" />
            </CTA>
            <div>
              <a className={styles.modalLink} href={"https://apps.apple.com/account/subscriptions"}>
                <T id="UpdatePayment.cancelOnDesktop" defaultMessage="Cancel on desktop with iTunes" />
              </a>
            </div>
            <div className={styles.last}>
              <a className={styles.modalLink} onClick={this.showDialog}>
                <T id="UpdatePayment.cancelOnMobile" defaultMessage="Cancel on mobile phone" />
              </a>
            </div>
          </div>
          <div className={styles.upsellImage}>
            {accountLevel === 2 ? (
              <img
                src={premiumIcon}
                srcSet={`${premiumIcon} 1x, ${premiumIcon2x} 2x, ${premiumIcon3x} 3x`}
                alt="premium account icon"
              />
            ) : (
              <img
                src={basicIcon}
                srcSet={`${basicIcon} 1x, ${basicIcon2x} 2x, ${basicIcon3x} 3x`}
                alt="basic account icon"
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}
